import { ICON_HOME_CITY_OUTLINE, ICON_MAP_MARKER_OUTLINE } from '@doveit/bricks';
import { CompositeGeoSearchCriterion, GeoSearchCriterionType } from '../../providers/api/dtos/searchCriteria';

export function getGeoCriterionIcon(geo: CompositeGeoSearchCriterion) {
  return geo.type === GeoSearchCriterionType.POINT
    ? ICON_HOME_CITY_OUTLINE
    : ICON_MAP_MARKER_OUTLINE;
}
